import { connect } from 'react-redux'

// const withPortalId = connect(({ portal }) => ({
//   portalId: portal._id,
// }))

const withPortalId = connect(({ info }) => ({ portalId: info.portalId }))

export default withPortalId



// WEBPACK FOOTER //
// ./src/modules/portal/withPortalId.js